import moment from 'moment';
let startDt = moment().startOf('month').format('YYYY-MM-DD');
let endDt = moment().endOf('month').format('YYYY-MM-DD');

export default {
	isMqyStation: false,

	searchParams: SEARCH_PARAMS(),
	pagingInfo: PAGING_INFO(), //페이지 정보
	rptpStList: [], //조회조건 고품상태목록
	srchMmList: [], //조회조건
	rtnPartMstList: [], //고품회수목록
	rtnPartInfo: RTN_PART_INFO(), //고품회수신청 상세정보

	clctWayList: [], // 수요상태 콤보박스
	dlvfYnList: [] // 택배비지불 콤보박스
};

function SEARCH_PARAMS() {
	return {
		rptpSt: '10' /* 고품회수상태 */,
		clctWay: '' /* 회수방법 */,
		aplcDd: '' /* 신청일 */,
		causPartNo: '' /*원인부품번호 */,
		srchMm: '10' /*고품회수_조건일 */,
		startDd: startDt,
		endDd: endDt,
		dlrCpnyCd: ''
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}

function RTN_PART_INFO() {
	return {
		roNo: '', //Ro No
		rptpNo: '', // 고품관리번호
		rptpSt: '', // 고품회수상태
		aplcId: '', // 신청자ID
		aplcDept: '', // 신청부서
		aplcDd: '', // 신청일자
		//dmdSt: '', // 수요상태
		clctWay: '', //회수방법
		aplcTel: '', // 신청자연락처
		aplcCo: '', // 신청자회사명
		sgtn: '', // 건의사항
		rcpnDd: '', // 수신일자
		rcptNm: '', // 수신자
		rcptTel: '', // 수신자 연락처
		dlvsCpnyCd: '', // 택배회사
		pctn: '', // 주의사항
		rcpnAdr: '', // 수신주소
		dspaDd: '', // 발신일자
		dsprNm: '', // 발신자
		clctNm: '', //회수자
		dsprTel: '', // 발신자 연락처
		dlvsNo: '', // 택배번호
		dlvfYn: '', // 택배비여부
		rson: '', // 비고
		btnTsAuth1: false, // 임시저장버튼권한
		btnApAuth1: false, //신청버튼권한
		btnApprAuth: false, //확인완료버튼권한
		readOnlyAuth1: false, //리드온리구분값
		btnTsAuth2: false, // 임시저장버튼권한
		btnApAuth2: false, //신청버튼권한
		readOnlyAuth2: false //리드온리구분값
	};
}

export { SEARCH_PARAMS, RTN_PART_INFO, PAGING_INFO };
